import Dashboard from "../dashboard/Dashboard";

export default function Plans() {
  return (
    <section className="route-page plans-workspace-page">
      <div className="page-head compact-head">
        <div>
          <p className="eyebrow">Plan Library & Editor</p>
          <h2>Compact plan variables with step-by-step allocation</h2>
          <span>Budget and asset labels are edited together on each ladder row and autosaved to D1.</span>
        </div>
        <div className="status-pill">Autosave enabled</div>
      </div>
      <Dashboard workspace="plans" />
    </section>
  );
}
